import FourOhFour from 'components/FourOhFour/FourOhFour';
import SiteNav from 'containers/SiteNav/SiteNav';
import ProfileBanner from 'components/ProfileBanner/ProfileBanner';
import ProjectGrid from 'components/ProjectGrid/ProjectGrid';
import Project from 'containers/Project/Project';

export default {
  siteNav: SiteNav,
  fourOhFourComponent: FourOhFour,
  profileBanner: ProfileBanner,
  projectGrid: ProjectGrid,
  singleProjectComponent: Project,
};



// WEBPACK FOOTER //
// ./src/constants/typeComponentMap.js